import { setContext } from "apollo-link-context";
import { getToken } from "api/auth";

export const authLink = setContext((_, { headers }) => {
  const token = getToken();
  return { headers: { ...headers, authorization: token ? `JWT ${token}` : "" } };
});
